/**
 *  日本語の改行問題対策js
 *  https://www.npmjs.com/package/budou.js
 *
 * data-fix-cjk を指定した要素以下の日本語をbudou.jsで解析して単語単位で折り返せるようにする
 */
import Mikan from 'mikanjs';

const japaneseLineBreak = () => {
  const $target = $('[data-fix-cjk] p, .text-cjk').not('.no-cjk');
  $target.each((i, e) => {
    const text = $(e).text();
    const replaceText = Mikan(text);
    $(e).html(replaceText);
  });
  if ($.fn.matchHeight) {
    $.fn.matchHeight._update();
  }
};

export default japaneseLineBreak;



// WEBPACK FOOTER //
// ./src/scripts/common/japaneseLineBreak.js